/**
 * The handful of settings the browser itself needs, fetched once before the
 * app renders.
 *
 * Only the Cesium Ion token lives here, and it is here rather than in local
 * storage for one reason: the token used to be per-visitor, so a visitor who
 * had not pasted their own saw a setup notice instead of a globe. One
 * deployment now has one token, set by the owner at /admin, and every visitor
 * gets the map.
 *
 * This is fetched before `createRoot`, not inside a component, because Cesium
 * reads `Ion.defaultAccessToken` when its module first loads. A React effect
 * would run after that import had already happened and the globe would come up
 * unauthenticated.
 */

let cesiumToken = "";
let loaded = false;

export async function loadPublicConfig(): Promise<void> {
  try {
    const res = await fetch("/api/settings/public", { credentials: "same-origin" });
    if (res.ok) {
      const body = await res.json();
      const token = body?.data?.cesium_ion_token;
      if (typeof token === "string") cesiumToken = token.trim();
    }
  } catch {
    // Offline, or the API is down. The globe falls back to its setup notice
    // and every other page still renders — none of them need this token.
  } finally {
    loaded = true;
  }
}

/** The deployment's Cesium Ion token, or "" when the owner has not set one. */
export function cesiumIonToken(): string {
  return cesiumToken;
}

export function publicConfigLoaded(): boolean {
  return loaded;
}
